// Module
var code = "<div id=\"V-0D15EB8B-E31C-4F69-B04C-39F3F00267FE\" data-b-itemsSource=\"{Binding internalItems,ViewSelector:templateSelector}\"> </div> ";
// Exports
export default code;